/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import 'bootstrap'
import '../sass/index.scss'
import { Loader } from '@googlemaps/js-api-loader'
import { setNavBarActiveLink } from './header'
import { displayShareModal } from './components/share-modal'

function subscribeToShareButton () {
  const placeName = document.getElementById('place-card-name').textContent

  const shareData = {
    text: `Visto en POiN - ${placeName}`,
    url: window.location.href
  }

  document.getElementById('share-place-btn').addEventListener('click', async () => {
    try {
      await navigator.share(shareData)
    } catch (e) {
      if (e instanceof TypeError && e.message === 'navigator.share is not a function') {
        displayShareModal(shareData.url)
      }
      console.error(e)
    }
  })
}

function subscribeToRatingButton () {
  const ratingButtons = document.getElementsByClassName('rating-button')

  if (ratingButtons.length !== 0) {
    const tForm = window.typeformEmbed.makePopup(ratingURL, {
      autoOpen: false,
      hideFooter: false,
      hideHeaders: true,
      onSubmit: () => {
        console.log('submitted')
        setTimeout(() => tForm.close(), 5000)
      }
    })
    ratingButtons.forEach(rb => rb.addEventListener('click', () => tForm.open()))
  }
}

async function initMap () {
  const mapContainer = document.getElementById('map')

  if (mapContainer) {
    console.log('initMap')
    const loader = new Loader({
      apiKey: window.googleApiKey,
      version: 'weekly'
    })

    await loader.load()

    const coords = JSON.parse(document.getElementById('place-coords').textContent)
    const map = new google.maps.Map(document.getElementById('map'), {
      zoom: 15,
      center: coords,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false
    })
    const marker = new google.maps.Marker({
      position: coords,
      map: map
    })
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  setNavBarActiveLink()
  subscribeToShareButton()
  subscribeToRatingButton()
  await initMap()
})
